module.exports = __webpack_public_path__ + "img/zlzx1.30747305.png";